import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import { IUserSummary } from '../../types/global/helper';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { IAvatar, ThspianAvatar } from '../Avatar/ThspianAvatar';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { formatNumberWithK } from '../../utils/AppUtils';
import { isEmpty } from 'lodash';

interface IUserGroup {
    users?: IUserSummary[];
    userCount?: number;
    maxAvatarDisplay?: number;
    label?: string;
    avatarStyle?: Omit<IAvatar, 'user'>;
    labelStyle?: SxProps<Theme>;
}
export const UserGroup: React.FC<IUserGroup> = ({
    userCount,
    users,
    maxAvatarDisplay,
    label,
    avatarStyle,
    labelStyle,
}) => {
    const { themeStyle } = useThemeContext();

    return (
        <Stack direction="row" spacing={1} marginTop={2} alignItems="center">
            <Box
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                sx={{ paddingTop: '5px', gap: '5px', cursor: 'pointer' }}>
                {users && users.length > 0 && (
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${maxAvatarDisplay}, 10px)`,
                        }}>
                        {users.slice(0, maxAvatarDisplay).map((user, index) => (
                            <Box
                                key={index}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: `1px solid ${theme[themeStyle].pure_black}`,
                                    borderRadius: 30,
                                }}>
                                <ThspianAvatar
                                    user={user}
                                    sx={{ width: 20, height: 20 }}
                                    disableVerified
                                    size="small"
                                    badgeSx={{
                                        border: `1px solid ${theme[themeStyle].tag_white}`,
                                        borderRadius: '50%',
                                    }}
                                    {...avatarStyle}
                                />
                            </Box>
                        ))}
                    </Box>
                )}
                {userCount && users && userCount - users?.length > 0 ? (
                    <Typography
                        sx={{
                            fontSize: 12,
                            fontWeight: '600',
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                            color: theme[themeStyle].darkGray,
                            ...labelStyle,
                        }}>
                        +{formatNumberWithK(userCount - users?.length)} {label}
                    </Typography>
                ) : (
                    !isEmpty(users) && (
                        <Typography
                            sx={{
                                fontSize: 12,
                                fontWeight: '600',
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                color: theme[themeStyle].darkGray,
                                ...labelStyle,
                            }}>
                            {label}
                        </Typography>
                    )
                )}
            </Box>
        </Stack>
    );
};
